<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Kommende {{this.typeAuction}}</h4>
      </div>

      <div class="shrink">
        <div class="select-container small has-popover" :class="{'popover-active': filterPopoverActive}" @click="toggleFiltersPopover()">
          <a class="button-select" href="javascript:;">
            <span class="title"><span>{{selectedFilter.val}}</span></span>
            <span class="glyph"><svg viewBox="0 0 6 12"><use xlink:href="/static/sprites.svg#glyph-input-select-tiny"></use></svg></span>
          </a>

          <span class="popover select-dropdown-popover align-x-right align-y-bottom small">
            <div>
              <ul>
                <li v-for="item in auctionFilters" :key="item.key" :class="{'active': item.key === selectedFilter.key}">
                  <a href="javascript:;" @click="setFilter(item)"><span>{{item.val}}</span></a>
                </li>
              </ul>
            </div>
          </span>
        </div>
      </div>

    </div>

    <router-link :to="{ name: 'AuksjonForm', params: {avdeling: this.$route.params.avdeling} }" class="button action fixed right">
      Ny Auksjon
    </router-link>

    <TheLoader :active="loading"/>

    <table v-if="!loading" class="large fixed clickable" style="width: 100%" :style="{ opacity: loading ? 0.5 : 1 }">
      <thead>
        <tr>
          <th>{{this.typeAuction}}</th>
          <th>NettauksjonsID</th>
          <th>Antall</th>
        </tr>
      </thead>
      <tbody v-if="auctionList.length > 0">
        <tr v-for="(auction) in auctionList" v-bind:key="auction.NettauksjonsID" @click="editItem(auction)">
          <td>{{auction.Navn}}</td>
          <td>{{auction.NettauksjonsID}}</td>
          <td>{{auction.antall}}</td>
        </tr>
      </tbody>
      <tbody v-else-if="!loading">
        <tr><td colspan="12"><em>Fant ingen auksjoner...</em></td></tr>
      </tbody>
    </table>
    <template v-if="pageCount > 1">
      <div class="pagination-container" style="margin-top: 0; padding: 1rem 0;">
        <paginate v-model="changePage"
          :page-count="pageCount"
          :page-range="3"
          :click-handler="setPage"
          :container-class="'pagination'"
          :prev-text="paginationArrow"
          :next-text="paginationArrow"
          :prev-class="'prev'"
          :next-class="'next'"
          >
        </paginate>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Auksjon',
  components: {},
  data () {
    return {
      currentPage: 1,
      auctionFilters: [
        {key: 'pending', val: 'Avventer'},
        {key: 'active', val: 'Aktiv'},
        {key: 'completed', val: 'Fullført'},
        {key: 'noobjects', val: 'Ingen gjenstander'}
      ],
      filterPopoverActive: false,
      selectedFilter: {key: 'pending', val: 'Avventer'},
      typeAuction: ''
    }
  },
  created () {
    let filter = localStorage[`auction_${this.$route.params.avdeling}_filter`]
    if (!filter) {
      filter = 'pending'
    }
    this.selectedFilter = this.auctionFilters.filter(obj => obj.key === filter)[0]
    this.loadAuctionList(filter)
  },
  mounted () {
    this.setTypeAuction()
  },
  computed: {
    ...mapGetters('nettauksjon', [
      'loading',
      'auctionList',
      'pageCount',
      'totalCount'
    ])
  },
  methods: {
    setPage: function (page) {
      const vm = this

      window.jQuery('html').animate({
        scrollTop: 0
      }, 200, function () {
        vm.currentPage = page
        vm.loadAuctionList()
      })
    },
    loadAuctionList: function (filter) {
      let params = {
        'avdeling': this.$route.params.avdeling,
        'filter': filter || this.selectedFilter.key,
        'page': this.currentPage || 1
      }
      this.$store.dispatch('nettauksjon/loadAuctionList', params)
    },
    editItem: function (auction) {
      this.$router.push({name: 'AuksjonForm', params: {avdeling: this.$route.params.avdeling, id: auction.NettauksjonsID}})
    },
    setFilter: function (filter) {
      this.selectedFilter = filter || null
      localStorage[`auction_${this.$route.params.avdeling}_filter`] = filter.key
      this.loadAuctionList(filter.key)
    },
    toggleFiltersPopover: function () {
      this.filterPopoverActive = !this.filterPopoverActive
    },
    setTypeAuction: function () {
      switch (this.$route.params.avdeling) {
        case 'nett':
          this.typeAuction = 'Nettauksjon'
          break
        case 'klassisk':
          this.typeAuction = 'Klassisk auksjon'
          break
        case 'vin':
          this.typeAuction = 'Vinauksjon'
          break
        default:
          this.typeAuction = 'Nettauksjon'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Auctions/Auksjon/Auksjon.vue